import Tooltip from "components/Tooltip"
import { memo, useCallback } from "react"
import { AiOutlineClose, AiOutlineDelete, AiOutlineEdit, AiOutlineSave } from "react-icons/ai"
import styled from "styled-components"
import { Colors } from "themes/palette"

const Container = styled.div`
  display: flex;
  gap: 4px;
  height: 48px;
  margin-top: 20px;
`

interface Props {
  isEditing: boolean
  setEditKey: React.Dispatch<React.SetStateAction<string | null>>
  modalType?: string
  index: number
  integration: App.Integrations
  integrationList: App.Integrations[]
  setIntegrationList: React.Dispatch<React.SetStateAction<App.Integrations[]>>
  onIntegrationListChange: (newIntegrationList: App.Integrations[]) => void
  isAddingNew: boolean
}

const ActionsButtons = (props: Props) => {
  const {
    isEditing,
    setEditKey,
    modalType,
    integration,
    integrationList,
    setIntegrationList,
    onIntegrationListChange,
    index,
    isAddingNew
  } = props

  const handleEditIntegration = useCallback(() => {
    setEditKey(integration.key)
  }, [integration.key])

  const handleSaveEdit = useCallback(() => {
    const updatedIntegrationList = integrationList.map((int) => {
      if (int.key === integration.key) {
        return integration
      }

      return int
    })

    setIntegrationList(updatedIntegrationList)
    onIntegrationListChange(updatedIntegrationList)
    setEditKey(null)
  }, [integrationList, setIntegrationList, onIntegrationListChange])

  const handleCancelEdit = useCallback(() => {
    setEditKey(null)
  }, [])

  const handleDeleteClick = useCallback(() => {
    setIntegrationList((prevIntegrationList) => {
      const newIntegrationList = [...prevIntegrationList]

      newIntegrationList.splice(index, 1)
      onIntegrationListChange(newIntegrationList)

      return newIntegrationList
    })
  }, [setIntegrationList, onIntegrationListChange])

  return (
    <>
      {(modalType === "create" || (modalType === "update" && isAddingNew)) && (
        <Container>
          <button type="button" onClick={handleDeleteClick}>
            <Tooltip text="Deletar">
              <AiOutlineDelete size={20} color={Colors.error} />
            </Tooltip>
          </button>
        </Container>
      )}
      {modalType === "update" && !isAddingNew && (
        <>
          {isEditing && (
            <Container>
              <button type="button" onClick={handleSaveEdit}>
                <Tooltip text="Salvar">
                  <AiOutlineSave size={20} color={Colors.primary_one} />
                </Tooltip>
              </button>
              <button type="button" onClick={handleCancelEdit}>
                <Tooltip text="Cancelar">
                  <AiOutlineClose size={20} color={Colors.error} />
                </Tooltip>
              </button>
            </Container>
          )}
          {!isEditing && (
            <Container>
              <button type="button" onClick={handleEditIntegration}>
                <Tooltip text="Editar">
                  <AiOutlineEdit size={20} color={Colors.primary_one} />
                </Tooltip>
              </button>
              <button type="button" onClick={handleDeleteClick}>
                <Tooltip text="Deletar">
                  <AiOutlineDelete size={20} color={Colors.error} />
                </Tooltip>
              </button>
            </Container>
          )}
        </>
      )}
    </>
  )
}

export default memo(ActionsButtons)
